import { render, staticRenderFns } from "./PurchaseTrainingPendingModal.vue?vue&type=template&id=5970702f&"
import script from "./PurchaseTrainingPendingModal.vue?vue&type=script&lang=js&"
export * from "./PurchaseTrainingPendingModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports